import { render, staticRenderFns } from "./global-modal.vue?vue&type=template&id=e0ea5f32&scoped=true&"
import script from "./global-modal.vue?vue&type=script&lang=js&"
export * from "./global-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ea5f32",
  null
  
)

export default component.exports